import { fetchWrapper } from "@/helpers/fetch-wrapper";
import { defineStore } from "pinia";
import { useUIStore } from "./ui.store";
import { parseISO, isValid, format } from "date-fns";
import { useAuthStore } from "./auth.store";

const baseUrlCredits = `/api/credits`;
const baseUrlTransactions = `/api/transactions`;

export const useTransactionStore = defineStore({
  id: "transaction",
  state: () => ({
    credits: 0,
    transactions: [] as TransactionType[],
  }),
  actions: {
    async getMyCredits() {
      const authStore = useAuthStore();
      if (!authStore.isAuth) {
        return;
      }
      const uiStore = useUIStore();
      uiStore.startLoading();
      await fetchWrapper
        .get(`${baseUrlCredits}`)
        .then(({ data }) => (this.credits = data))
        .catch((error) => {
          console.log(error);
          uiStore.showMessage("error", error);
        })
        .finally(() => uiStore.stopLoading());
    },
    addCredits(id: string, ammount: number) {
      const self = this;
      const uiStore = useUIStore();
      uiStore.startLoading();
      return fetchWrapper
        .post(`${baseUrlTransactions}/${id}`, { ammount })
        .then(() => {
          self.fetchTransactions(); // Recarrega as transações para atualizar a tabela
        })
        .catch((error) => {
          console.error("Error adding credits:", error);
          uiStore.showMessage("error", error.message || "Error adding credits");
        })
        .finally(() => {
          self.getMyCredits();
          uiStore.stopLoading();
        });
    },
    async fetchTransactions() {
      const uiStore = useUIStore();
      uiStore.startLoading();
      try {
        const response = await fetchWrapper.get(`${baseUrlTransactions}`);
        this.transactions = response.data;
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
        uiStore.showMessage("error", "Failed to fetch transactions");
      } finally {
        uiStore.stopLoading();
      }
    },
  },
});
